<template>
    
    <div v-if="(uiStore.isMobile || uiStore.isTablet)" class="sticky-top position-relative" :style="uiStore.isMobile ? 'margin-top:-90px;' : 'margin-top:56px;'">
        <template v-if="mapAndSearchReady">
            <div :style="`height: ${mapHeight};`" ref="propertiesMap"></div>

            <div v-if="showPropertyOverMapId" style="background:rgba(0, 0, 0, 0.35);"  class="position-absolute top-0 end-0 start-0 end-0 h-100 w-100 d-flex align-items-center justify-content-center" @click.stop="closeMapCard">

                <div class="bg-body rounded" style="min-width:300px;" @click.stop>
                    <property-card-from-id :propertyId="showPropertyOverMapId" :checkIn="checkIn" :checkOut="checkOut" :quotePerNight="quotePerNight" :useBedsCount="useBedsCount" />
                </div>

            </div>
            <div v-else class="position-absolute top-0 end-0 mt-3 pt-3 me-3">
                <ui-button color="secondary" @click="mapCloseButton" class="rounded-1">
                    <i class="fas fa-times"></i>
                </ui-button>
            </div>
        </template>
        <divider v-else />
    </div>

    <div class="position-relative bg-body rounded-top" :style="contentContainerStyle">
        <div class="py-3 py-md-4 py-lg-5 content-container" ref="resultsContainer">
            <alert v-if="error">
                {{ error }}
            </alert>
            
            <container>
                <row>
                    <column v-if="properties" :lg="8">

                        <template v-if="searching">
                            <div class="d-flex mb-4 align-items-center justify-content-between">
                                <h5 class="mb-0">
                                    Loading Results
                                </h5>
                                <spinner size="sm" />
                            </div>
                        </template>

                        <div v-else-if="uiStore.isMobile || uiStore.isTablet" class="d-flex mb-4 me-0 me-md-3 align-items-center justify-content-between clickable" @click="toggleResults">
                            <h5 class="mb-0">
                                Discover more properties
                            </h5>
                            <i v-if="viewingProperties" class="fas fa-arrow-down"></i>
                            <i v-else class="fas fa-arrow-up"></i>
                        </div>

                        <container class="pt-3 pb-4">
                            <row>
                                <column :col="20" :md="14" :lg="20" class="d-flex align-items-baseline">
                                    <h2>Book a Property</h2>
                                    <h3 v-if="resultsCount" class="ms-2 text-primary">({{ resultsCount }})</h3>
                                </column>
                                <column :col="4" :md="10" :lg="4" class="d-flex align-items-center justify-content-end">
                                    <button-group v-if="uiStore.isTablet && quotes" class="mb-3 me-1">
                                        <ui-button :underline="true" :color="quotePerNight ? 'light' : 'primary'" @click="$emit('setDisplayQuotePerStay')">
                                            $USD / Stay
                                        </ui-button>
                                        <ui-button :underline="true" :color="quotePerNight ? 'primary' : 'light'" @click="$emit('setDisplayQuotePerNight')">
                                            $USD / Night
                                        </ui-button>

                                    </button-group>
                                    
                                    <ui-button class="mb-3 border-0 hover-bg-info d-inline-flex align-items-center" @click="goToGrid" color="none" :size="uiStore.isMobile ? 'sm' : 'md'">
                                        <grid-icon :size="20"/>
                                    </ui-button>
                                </column>
                            </row>
                        </container>

                        <button-group v-if="!uiStore.isTablet && quotes" size="sm" class="mb-4 w-100">
                            <!-- outline when not selected -->
                            <ui-button :outline="quotePerNight" @click="$emit('setDisplayQuotePerStay')">
                                $USD / Stay
                            </ui-button>
                            <ui-button :outline="!quotePerNight" @click="$emit('setDisplayQuotePerNight')">
                                $USD / Night
                            </ui-button>

                        </button-group>

                        <container>
                            <row>
                                <column :md="12" :lg="24" v-for="property in properties" :key="`properties-standard-list-${property.id}`" class="pb-4">
                                    <property-common-card class="md-h-100 lg-h-auto" :property="property" :checkIn="checkIn" :checkOut="checkOut" :quotePerNight="quotePerNight" :useBedsCount="useBedsCount" @onHover="onPropertyHover" @offHover="offPropertyHover" />
                                </column>

                                <column :md="12" :lg="24" class="pb-4">
                                    <personal-approach-card :checkIn="checkIn" :checkOut="checkOut" :adults="adults" :children="children" class="md-h-100 lg-h-auto"/>
                                </column>
                            </row>
                        </container>
                    </column>

                    <column v-else-if="emptyResults" :lg="8">

                        <template v-if="searching">
                            <div class="d-flex mb-4 align-items-center justify-content-between">
                                <h5 class="mb-0">
                                    Loading Results
                                </h5>
                                <spinner size="sm" />
                            </div>
                        </template>
                        
                        <properties-empty-results :checkIn="checkIn" :checkOut="checkOut" :adults="adults" :children="children" :stacked="true"/>
                    </column>

                    <column v-else-if="!error" :lg="8">

                        <div class="d-flex mb-4 align-items-center justify-content-between">
                            <h5 class="mb-0">
                                Loading Results
                            </h5>
                            <spinner size="sm" />
                        </div>

                    </column>

                    <column v-if="!uiStore.isMobile && !uiStore.isTablet" :lg="16" class="position-relative ps-lg-5">
                        <div class="sticky-top" :style="stickyQuotePositionStyle">
                            <template v-if="mapAndSearchReady">
                                <div class="vh-70 rounded" ref="propertiesMap"></div>

                                <div v-if="showPropertyOverMapId" style="background:rgba(0, 0, 0, 0.35);" @click.stop="closeMapCard" class="position-absolute top-0 end-0 start-0 end-0 h-100 w-100 d-flex align-items-center justify-content-center">

                                    <div class="bg-body rounded" style="min-width:320px;" @click.stop>
                                        <property-card-from-id :propertyId="showPropertyOverMapId" :checkIn="checkIn" :checkOut="checkOut" :quotePerNight="quotePerNight" :useBedsCount="useBedsCount" />
                                    </div>

                                </div>
                                <div v-else class="position-absolute top-0 end-0 mt-3 me-3">
                                    <ui-button color="secondary" @click="mapCloseButton" class="rounded-1">
                                        <i class="fas fa-times"></i>
                                    </ui-button>
                                </div>
                            </template>

                            <div v-else class="text-center my-4">
                                <i class="fas fa-map-marked-alt fs-2"></i>
                                <p class="small text-muted">Map Loading</p>
                            </div>
                        </div>
                    </column>
                </row>
            </container>

            <divider height="sm"/>
            <pagination v-if="properties" :collection="properties" @change="changePage" class="mt-5" />
            <divider />
        </div>

        
    </div>
</template>

<script type="text/javascript">
    /*global google*/
    import MapConfig from '@/config/maps.json';
    import { MarkerClusterer } from "@googlemaps/markerclusterer";
    
    import PropertyCommonCard from '@/components/Content/Public/Properties/Cards/Common.vue';
    import PropertyCardFromId from '@/components/Content/Public/Properties/Cards/FromId.vue';
    import PersonalApproachCard from '@/components/Content/Public/Properties/Cards/PersonalApproach.vue';
    import PropertiesEmptyResults from '@/components/Content/Public/Properties/Lists/Empty.vue';
    import GridIcon from '@/assets/icons/grid.svg.vue';
    import CommonComponents from '@/components/Common.vue';

    import Collection from '@/classes/Collection.js';
    import DateObject from '@/classes/DateObject.js';
    import GoogleMaps from '@/classes/Google/Maps/Maps.js';
    import Api from '@/classes/Api.js';

    import { UseUIStore } from '@/store/UI.js';
    

    export default {
        components: {
            PropertyCommonCard,
            PropertyCardFromId,
            PersonalApproachCard,
            PropertiesEmptyResults,
            GridIcon,
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                mapReady: false,
                mapCreated: false,
                disposed: false,

                markersScriptLoaded: false,

                mapPropIds: null,
                updateMapParamTimer: null,
                resetBounds: true,
                goToResultsOnSearch: false,
                autoZoom: false,

                showPropertyOverMapId: null,
                isShowingMapCard: false,
                mounted: false,
            };
        },

        emits: ['mapUpdated', 'changePage', 'goToGrid', 'setDisplayQuotePerStay', 'setDisplayQuotePerNight'],
        
        props: {
            // search bar compenent from the parent
            searchBar: {
                type:null,
            },

            error: {
                type: String,
            },
            
            searching: {
                type: Boolean,
            },

            emptyResults: {
                type: Boolean,
            },

            properties: {
                type: Collection,
            },

            checkIn: {
                type: DateObject,
            },

            checkOut: {
                type: DateObject,
            },

            adults: {
                type: Number,
            },

            children: {
                type: Number,
            },

            quotePerNight: {
                type: Boolean,
                default: false,
            },

            useBedsCount: {
                type: Boolean,
                default: false,
            },

            resultsCount: {
                type: Number,
            },

            // when the search bar loads
            searchBarReady: {
                type: Boolean,
                default: false,
            },

            refreshMap: {
                type: Number,
                default: 0,
            },

            quotes: {
                type: Object,
            },
        },

        async mounted() {
            if (await Api.isOnline(true)) {
                this.mapReady = await GoogleMaps.ready();
            }

            window.addEventListener('resize', this.reCreateMap, {passive: true});
            this.mounted = true;

            // track the markers to dispose them
            // none reactive
            // this.mapMarkers;
            // ths.map;
            // this.mapClusterer
        },

        beforeUnmount() {
            this.disposed = true;
            
            window.removeEventListener('resize', this.reCreateMap, {passive: true});

            this.disposeMarkers();
            if (this.map) {
                google.maps.event.clearInstanceListeners(this.map);
            }
            delete this.map;
        },

        watch: {
            mapAndSearchReady() {
                this.createMap();
            },

            refreshMap() {
                this.createCircles();
            },

            searching(newVal) {
                if ((!newVal) && (this.goToResultsOnSearch)) {
                    this.goToResults();
                    this.goToResultsOnSearch = false;
                }
            },
        },

        computed: {
            mapHeight() {
                if (this.uiStore.isMobile) {
                    return 'calc(100svh - 200px)';
                }
                return '60vh';
            },

            contentContainerStyle() {
                if ((this.uiStore.isMobile) || (this.uiStore.isTablet)) {
                    return 'z-index:1024; margin-top:-3px;';
                }
                return null;
            },

            mapAndSearchReady() {
                if ((this.mapReady) && (this.searchBarReady)) {
                    return true;
                }

                return false;
            },

            stickyQuotePositionStyle() {
                let top = 50;
                if (this.uiStore.stickTopNavTop) {
                    top += this.uiStore.stickTopNavTop;
                    
                }

                top += 80;
                return 'top: '+top+'px;';
            },

            viewingProperties() {
                let scrollTop = this.uiStore.scrollTop;
                if ((this.mounted) && (this.$refs.resultsContainer)) {
                    let y = this.$refs.resultsContainer.getBoundingClientRect().top;
                    if (y < scrollTop) {
                        return true;
                    }

                }

                return false;
            },

        },

        methods: {

            reCreateMap() {
                if (
                    (this.mapCreated) &&
                    (!this.disposed) &&
                    (this.$refs.propertiesMap) &&
                    (!this.$refs.propertiesMap.dataset.hasMap)
                ) {
                    this.mapCreated = false;
                    this.showPropertyOverMapId = null;
                    this.disposeMarkers();
                    requestAnimationFrame(function() {
                        this.createMap();
                    }.bind(this));
                }
                
            },

            async createMap() {
                if (
                    (this.mapCreated) ||
                    (this.disposed)
                ) return;

                if (!this.$refs.propertiesMap) {
                    setTimeout(this.createMap, 250);
                    return;
                }
                
                this.mapCreated = true;

                let mapOptions = {
                    center: new google.maps.LatLng(MapConfig.offices[0].lat, MapConfig.offices[0].lng),
                    zoom: 7,
                    maxZoom: 14,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    gestureHandling: 'cooperative',
                    styles: MapConfig.styles.frontEnd,
                    panControl: false,
                    zoomControl: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    zoomControlOptions: {
                        style: google.maps.ZoomControlStyle.SMALL,
                        position: google.maps.ControlPosition.RIGHT_BOTTOM
                    },
                    mapTypeControlOptions: {
                        position: google.maps.ControlPosition.BOTTOM_LEFT
                    },
                    clickableIcons: false,
                };
                
                if (!this.$refs.propertiesMap) {
                    return;
                }
                this.map = new google.maps.Map(this.$refs.propertiesMap, mapOptions);

                this.$refs.propertiesMap.dataset.hasMap = 1;

                this.map.addListener('bounds_changed', this.mapUpdateEvent);
                this.map.addListener('zoom_changed', this.mapUpdateEvent);

                this.createCircles();

            },

            async loadMarkersScript() {
                if (!this.markersScriptLoaded) {
                    let exports = await import('@/classes/Google/Maps/Marker.js');
                    this.GoogleMapsMarker = exports.default;
                    this.markersScriptLoaded = true;
                }
            },

            disposeMarkers() {
                
                if (this.mapMarkers) {
                    for (let i=0; i<this.mapMarkers.length; i++) {
                        google.maps.event.clearInstanceListeners(this.mapMarkers[i]);
                        this.mapMarkers[i].setMap(null);
                    }
                    
                    delete this.mapMarkers;
                }

                if (this.mapClusterer) {
                    this.mapClusterer.clearMarkers();
                    this.mapClusterer.setMap(null);
                    delete this.mapClusterer;
                }
            },

            async createCircles() {
                if ((this.disposed) || (!this.map)) {
                    return;
                }

                await this.loadMarkersScript();
                
                this.disposeMarkers();

                /**
                 * IMPORTANT, the properties in this response
                 * will have truncated keys
                 * e.g. instead of "name", it'll be "n"
                 * 'name'                  =>  'n',
                 * 'slug'                  =>  'sg',
                 * 'city_state_country'    =>  'c',
                 * 'market_id'             =>  'mId',
                 * 'bedrooms'              =>  'bd',
                 * 'bathrooms'             =>  'bt',
                 * 'service_level'         =>  'sl',
                 * 'max_occupancy'         =>  'oc',
                 * 'schedule_price_avg'    =>  'avg',
                 * 'public_lat'            =>  'lt',
                 * 'public_lng'            =>  'lg',
                 * 'pet_policy'            =>  'pt',
                 */
                let properties;
                if (this.searchBar) {
                    properties = this.searchBar.mapProperties();
                }

                if ((properties) && (properties.length)) {

                    let bounds = new google.maps.LatLngBounds();
                
                    let markersKeys = {};
                    let markers = [];
                    for (let i=0; i<properties.length; i++) {
                        let key = properties[i].lt+'x'+properties[i].lg;
                        if (!markersKeys[key]) {
                            markersKeys[key] = {
                                properties: [],
                                position: {lat: properties[i].lt, lng: properties[i].lg},
                            }
                        }
                        
                        markersKeys[key].properties.push(properties[i].id);
                    }

                    let values = Object.values(markersKeys);
                    for (let i=0; i<values.length; i++) {
                        let position = new google.maps.LatLng(values[i].position.lat, values[i].position.lng);
                        let marker = this._countMarker(values[i].properties.length, position);

                        marker._smProperties = values[i].properties;

                        marker.addListener('click', function() {

                            if (marker._smProperties.length == 1) {
                                this.isShowingMapCard = true;

                                setTimeout(function() {
                                    this.isShowingMapCard = false;
                                }.bind(this), 500);

                                this.showPropertyOverMapId = marker._smProperties[0];
                                return;
                            }

                            this.showPropertyOverMapId = null;

                            if (this.map.getZoom() <= 10) {

                                this.autoZoom = true;
                                setTimeout(function() {
                                    this.autoZoom = false;
                                }.bind(this), 500);
                                
                                this.map.setZoom(12);
                                this.map.setCenter(position);
                            }

                            this.mapPropIds = marker._smProperties;
                            this.goToResultsOnSearch = true;
                            this.updateMapParam();

                            setTimeout(this.goToResults, 500);
                        
                        }.bind(this));
                        
                        bounds.extend(position);
                        markers.push(marker);
                    }

                    if (this.resetBounds) {
                        this.map.fitBounds(bounds);
                    }
                    else {
                        setTimeout(function() {
                            this.resetBounds = true;
                        }.bind(this), 500);
                    }

                    this.mapMarkers = markers;

                    this.mapClusterer = new MarkerClusterer({
                        map: this.map,
                        markers: this.mapMarkers,
                        renderer: this._clusterRender(),
                    });
                }
                else {
                    this.map.setZoom(7);
                    this.map.setCenter(new google.maps.LatLng(MapConfig.offices[0].lat, MapConfig.offices[0].lng));
                }
            },

            _markerSvg(count, color) {
                if (!color) color = '#1b1943';
                return `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50"><circle cx="120" cy="120" opacity=".6" r="70" /><circle cx="120" cy="120" opacity=".3" r="90" /><circle cx="120" cy="120" opacity=".2" r="110" /><text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text></svg>`;
            },

            _countMarker(count, position) {
                // create svg literal with fill color
                const svg = this._markerSvg(count);

                // adjust zIndex to be above other markers
                const zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;

                const clusterOptions = {
                    position,
                    zIndex,
                    icon: {
                        url: `data:image/svg+xml;base64,${btoa(svg)}`,
                        anchor: new google.maps.Point(25, 25)
                    }
                };
                let marker = new google.maps.Marker(clusterOptions);

                // caching the count so we can
                // update the icon color svg
                marker._smCount = count;
                return marker;
            },

            _clusterRender() {

                return {
                    render: function (_ref) {
                        let count = _ref.count;
                        let position = _ref.position;

                        // we need to update the count based
                        // on the number of properties in the markers
                        if (_ref.markers) {
                            count = 0;
                            for (let i=0; i<_ref.markers.length; i++) {
                                count += _ref.markers[i]._smProperties.length;
                            }
                        }

                        return this._countMarker(count, position);
                        
                    }.bind(this),
                };
            },

            mapParams() {
                let params = {};

                if (this.mapPropIds) {
                    params.mapPropIds = this.mapPropIds.join(',');
                }
                else if (this.map) {
                    let bounds = this.map.getBounds();
                    let northEast = bounds.getNorthEast();
                    let southWest = bounds.getSouthWest();

                    params.minLat = southWest.lat().toFixed(4);
                    params.maxLat = northEast.lat().toFixed(4);
                    params.minLng = southWest.lng().toFixed(4);
                    params.maxLng = northEast.lng().toFixed(4);
                }

                if (Object.keys(params).length) {
                    return params;
                }
                return null;
            },

            mapUpdateEvent() {
                if ((this.autoZoom) || (this.showPropertyOverMapId)) {
                    return;
                }
                this.mapPropIds = null;
                this.updateMapParam();
            },

            updateMapParam() {
                clearTimeout(this.updateMapParamTimer);
                this.updateMapParamTimer = setTimeout(function() {
                    this.resetBounds = false;
                    this.$emit('mapUpdated');
                }.bind(this), 500);
            },

            toggleResults() {
                if (this.viewingProperties) {
                    this.uiStore.scrollWindow(0);
                }
                else {
                    this.goToResults();
                }
            },

            goToResults() {
                if (this.$refs.resultsContainer) {
                    let y = 0;
                    if ((this.goToResultsOnSearch) || (!this.viewingProperties)) {
                        y = this.$refs.resultsContainer.getBoundingClientRect().top + window.scrollY - 80;
                    }
                    this.uiStore.scrollWindow(y);
                }
            },

            changePage(page) {
                this.$emit('changePage', page)
            },

            onPropertyHover(property) {
                if (
                    (property) &&
                    (!this.uiStore.isMobile) &&
                    (!this.uiStore.isTablet)
                ) {
                    let foundMarker = false;
                    if (
                        (this.mapClusterer) &&
                        (this.mapClusterer.clusters) &&
                        (this.mapClusterer.clusters.length)
                    ) {
                        for (let i=0; i<this.mapClusterer.clusters.length; i++) {
                            
                            for (let j=0; j<this.mapClusterer.clusters[i].markers.length; j++) {

                                if (this.mapClusterer.clusters[i].markers[j]._smProperties.indexOf(property.id) != -1) {

                                    this.propertyHoverMarker = [];

                                    // cluster marker
                                    this.propertyHoverMarker.push(this.mapClusterer.clusters[i].marker);
                                    
                                    let svg = this._markerSvg(this.mapClusterer.clusters[i].marker._smCount, '#cc0000');
                                    this.mapClusterer.clusters[i].marker.setIcon({
                                        url: `data:image/svg+xml;base64,${btoa(svg)}`,
                                        anchor: new google.maps.Point(25, 25)
                                    });

                                    // property marker
                                    this.propertyHoverMarker.push(this.mapClusterer.clusters[i].markers[j]);

                                    svg = this._markerSvg(this.mapClusterer.clusters[i].markers[j]._smCount, '#cc0000');
                                    this.mapClusterer.clusters[i].markers[j].setIcon({
                                        url: `data:image/svg+xml;base64,${btoa(svg)}`,
                                        anchor: new google.maps.Point(25, 25)
                                    });

                                    break;
                                }
                            }

                            if (foundMarker) {
                                break;
                            }
                        }
                    }

                }
            },

            offPropertyHover() {
                if ((this.propertyHoverMarker) && (this.propertyHoverMarker.length)) {

                    for (let i=0; i<this.propertyHoverMarker.length; i++) {
                        const svg = this._markerSvg(this.propertyHoverMarker[i]._smCount);

                        this.propertyHoverMarker[i].setIcon({
                            url: `data:image/svg+xml;base64,${btoa(svg)}`,
                            anchor: new google.maps.Point(25, 25)
                        });
                    }

                    this.propertyHoverMarker = null;
                }
            },

            goToGrid() {
                this.$emit('goToGrid');
            },

            mapCloseButton() {
                if (this.showPropertyOverMapId) {
                    this.showPropertyOverMapId = null;
                }
                else {
                    this.goToGrid();
                }
            },

            closeMapCard() {
                if (this.isShowingMapCard) {
                    return;
                }
                this.showPropertyOverMapId = null;
            },
        },
    };

</script>
